import { Theme } from '@mui/material';

export const getTable = (theme: Theme) => {
    const { palette } = theme;
    return {
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '& td, & th': {
                        borderColor: palette.surfaceContainerHighest.main,
                    },
                    '&:last-child td, &:last-child th': {
                        borderBottom: 'unset',
                    },
                },
            },
        },
    };
};
